<template>
  <header class="relative z-110 background-pattern-navy-500--hero">
    <section class="website-header z-40 hidden xl:block bg-mbzuai-sand-500">
      <ContentContainer>
        <nav class="py-3 justify-end flex items-center gap-4 z-20">
          <Select
            v-model="selectedOption"
            :options="options"
            option-label="label"
            option-value="value"
            placeholder="Information for"
            :pt="{
              root: {
                class: ['bg-mbzuai-sand-300 border-0'],
              },
            }"
          />

          <!-- <SiteLanguageSwitcher v-if="useNuxtApp().$i18n" /> -->

          <MBZCTAButton
            severity="tertiary"
            button-label=""
            :icon="!isSearchPanelOpen ? 'search' : 'times'"
            icon-position="right"
            title="Toggle Global Site Search"
            aria-label="Toggle Global Site Search"
            @click="handleToggleSearchPanel"
          />

          <UserMenu />

          <MBZCTAButton
            label="Apply"
            icon-position="right"
            icon="arrow"
            severity="primary"
          />
        </nav>
      </ContentContainer>
    </section>

    <div class="website-header">
      <NavigationMain />
    </div>

    <Transition>
      <div
        v-if="isSearchPanelOpen || isMegamenuOpen"
        class="fixed z-800 bg-black/30 w-full min-h-dvh"
        @click="handleSiteOverlayClose"
      />
    </Transition>

    <!-- BREADCRUMBS & SECONDARY NAVIGATION -->
    <div class="website-header">
      <SecondaryNav v-if="slots.secondaryNavigation" :division="props.division">
        <slot name="secondaryNavigation" />
      </SecondaryNav>

      <!-- BREADCRUMBS -->
      <Breadcrumbs />
    </div>

    <slot name="hero" />
  </header>

  <!-- <SiteMessages /> -->
</template>

<script setup lang="ts">
const slots = useSlots();

type DivisionColor = {
  element?: string;
  darkVariant?: string;
  lightVariant?: string;
  name?: string;
};

type Division = {
  [key: string]: unknown;
  divisionType?: {
    name?: string;
    primaryColor?: DivisionColor[];
  };
};

const props = defineProps<{
  division?: Division;
}>();

const selectedOption = ref<string | number | null>(null);
const options = ref([
  { label: 'Option 1', value: 1 },
  { label: 'Option 2', value: 2 },
  { label: 'Option 3', value: 3 },
]);

const { isSearchPanelOpen, handleToggleSearchPanel } = useDrupalSearch();
const { isMegamenuOpen } = useMenu();
const { handleToggleMegamenu } = useMenu();

const handleSiteOverlayClose = () => {
  handleToggleSearchPanel();
  handleToggleMegamenu(null);
};
</script>

<style lang="scss" scoped>
// Override for header only, to match design
.website-header :deep(.content-container) {
  @media (width >= 80rem) {
    padding-left: 42px;
    padding-right: 42px;
  }
}
</style>
